"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var _convertHexToRgba = _interopRequireDefault(require("@kiwicom/orbit-design-tokens/lib/convertHexToRgba"));

var formElementFocus = function formElementFocus() {
  return (0, _styledComponents.css)(["box-shadow:", ";"], function (_ref) {
    var theme = _ref.theme,
        error = _ref.error;
    return error ? // TODO: UPDATE TOKENS ==> `${theme.orbit.borderWidthInputFocus} ${theme.orbit.borderColorInputFocus}`
    "inset 0 0 0 1px ".concat(theme.orbit.paletteRedNormal, ", 0 0 0 3px ").concat((0, _convertHexToRgba.default)(theme.orbit.paletteRedNormal, 15), ";") : "inset 0 0 0 1px ".concat(theme.orbit.borderColorInputFocus, ", 0 0 0 3px ").concat((0, _convertHexToRgba.default)(theme.orbit.borderColorInputFocus, 15), ";");
  });
};

var _default = formElementFocus;
exports.default = _default;